let d3 = window.d3 || null;

let is2160 = () => window._screenType === '2160';

let menuArr = ['性别分布', '消费水平分布', '年龄分布', '相似餐厅', '用户常驻城市']; // 仅存在一级子节点的
// https://d3js.org.cn/api/d3-force/#forces
let forceOption = (graph) => {
    graph.option.d3 && (d3 = graph.option.d3);
    let scale = graph.option.scale;

    let forceObj = {
        // 根据links创建的弹簧力模型
        forceLink:
            d3.forceLink()
                .id(d => d.id)
                .distance((link) => {
                    let unit = 30 * scale;
                    let { source, target } = link;
                    let distanceMap = { 1: unit, };
                    if (is2160()) {
                        if (target.depth === '3') {
                            distanceMap['3'] = 1;
                        }
                        let flag1to2 = false; // 性别分布 => 男（1 => 2）
                        let flag0to1 = false; // 眉州东坡 => 性别分布（0 => 1）
                        menuArr.forEach((item) => {
                            if (source.name.includes(item)) {
                                flag1to2 = true;
                            }
                            if (target.name.includes(item)) {
                                flag0to1 = true;
                            }
                        });
                        if (flag1to2) {
                            distanceMap['2'] = 1;
                        } else {
                            // distanceMap['2'] = -100;
                        }
                        if (flag0to1) {
                            distanceMap['1'] = 666;
                        }

                        // distanceMap['1'] = 66666;
                    } else {
                        if (target.depth === '3') {
                            distanceMap['3'] = 1;
                        }

                        let flag1to2 = false; // 性别分布 => 男（1 => 2）
                        let flag0to1 = false; // 眉州东坡 => 性别分布（0 => 1）
                        menuArr.forEach((item) => {
                            if (source.name.includes(item)) {
                                flag1to2 = true;
                            }
                            if (target.name.includes(item)) {
                                flag0to1 = true;
                            }
                        });
                        if (flag1to2) {
                            distanceMap['2'] = 1; // 男 女 末梢子节点
                        } else {
                            distanceMap['2'] = -270; // 还有最后一级子节点
                        }
                        if (flag0to1) {
                            distanceMap['1'] = 400;
                        } else {
                            distanceMap['1'] = 1;
                        }
                    }
                    let distance = distanceMap[target.depth];
                    return distance || unit;
                })
                .strength(function (link) {
                    let { source, target } = link;
                    let strengthMap = { 1: 3, };
                    if (is2160()) {
                        if (target.depth === '3') {
                            strengthMap['3'] = 1;
                        }
                        let flag = false; // 
                        menuArr.forEach((item) => {
                            if (source.name.includes(item)) {
                                flag = true;
                            }
                        });
                        if (flag) {
                            strengthMap['2'] = 2;
                        }
                    } else {
                        if (target.depth === '3') {
                            strengthMap['3'] = 3;
                        }

                        let flag = false; //
                        menuArr.forEach((item) => {
                            if (source.name.includes(item)) {
                                flag = true;
                            }
                        });
                        if (flag) {
                            strengthMap['2'] = 2;
                        }
                    }
                    let strength = strengthMap[target.depth];
                    return strength || 0.3;
                }),
        // 电荷力模型
        forceCharge:
            d3.forceManyBody()
                .strength((d) => {
                    let strengthMap = { 0: -15000, 1: -400, 2: -400 };
                    if (is2160()) {
                        strengthMap = { 0: 30000, 1: 30000, 2: -15000, 3: -3000 };
                        strengthMap = { 0: 30000, 1: 10000, 2: -15000, 3: -1000 };
                        strengthMap = { 0: 30000, 1: 10000, 2: -16667, 3: -1500 };
                        // strengthMap = { 0: 30000, 1: 0, 2: -15000, 3: -3000 };
                        // if (d.depth === '1') {
                        //     let arr = ['相似餐厅', '年龄分布'];
                        //     arr.forEach((item) => {
                        //
                        //         d.name.includes(item);
                        //         strengthMap[1] = -30000;
                        //     })
                        // }
                        let arr = ['男', '女'];
                    } else {
                        strengthMap = { 0: 3000, 1: 1000, 2: -3000, 3: -200 };
                    }
                    let strength = strengthMap[d.depth];
                    return strength || -30;
                }),
        // 碰撞半径
        forceCollide:
            d3.forceCollide().radius((d) => {
                let radius = 10;
                // 调整节点碰撞半径
                let depthMap = { 0: 150, 1: 50, 2: 70, 3: 20 };
                if (is2160()) {
                    // depthMap = { 0: 130, 1: 60, 2: 90, 3: 20 };
                    depthMap = { 0: 120, 1: 60, 2: 90, 3: 20 };
                    // depthMap[3] = 0
                }
                radius = depthMap[d.depth] * scale;
                if (d.isLeaf && d.depth === '2') {
                    radius = 20 * scale;
                }
                // if (d.depth === '1') {
                //     return 200;
                // }
                return radius;
            }),
        // 调整布局方案
        // forceX: d3.forceX(graph.width * 2).strength(0.05),
        // forceY: d3.forceY(graph.height * 2).strength(0.2),
        forceX: d3.forceX(graph.width * 2).strength(0.05),
        forceY: d3.forceY(graph.height * 2).strength(0.4),

    };
    if (is2160()) {
        // forceObj.forceX = d3.forceX(graph.width * 32).strength(0.03);
        // forceObj.forceY = d3.forceY(graph.height * 8).strength(0.5);
        forceObj.forceX = d3.forceX(graph.width * 2).strength(0.06);
        forceObj.forceY = d3.forceY(graph.height * 2).strength(0.4);
    }
    return forceObj;
};

export default forceOption;
